<div class="card mb-2">
  <div class="card-header">
    Addenda/Hard to Treat Cavity Walls
  </div>

  <div class="card-body">
    <p class="p-2 bg-primary-subtle">Hard to Treat Cavity Walls</p>
    <div class="d-flex align-items-center justify-content-between" style="width: 300px;">
      <p class="mb-1"> Access Issues</p>
      <input type="checkbox" [(ngModel)]="hardToTreatAccessIssues" (change)="updateHardToTreatCavityWallsSection()">
    </div>
    <div class="d-flex align-items-center justify-content-between" style="width: 300px;">
      <p class="mb-1"> High Exposure</p>
      <input type="checkbox" [(ngModel)]="hardToTreatHighExposure" (change)="updateHardToTreatCavityWallsSection()">
    </div>
    <div class="d-flex align-items-center justify-content-between" style="width: 300px;">
      <p class="mb-1"> Narrow Cavities</p>
      <input type="checkbox" [(ngModel)]="hardToTreatNarrowCavities" (change)="updateHardToTreatCavityWallsSection()">
    </div>
    <hr />
    <p class="mt-3 p-2 bg-primary-subtle">Addenda to EPC</p>
    <div *ngFor="let addendum of addendaOptions; let i = index">
      <label>
        <input type="checkbox" (change)="updateAddendaSelection(i, $event.target.checked)" [checked]="addendum.selected">
        {{ addendum.lookUpItem }}
      </label>
    </div>
  </div>
</div>
